export type NumericLike = string | number;

const toNumber = (value: NumericLike): number => {
  if (typeof value === 'number') return value;
  const parsed = parseFloat(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const creditsToCents = (credits: NumericLike): number => {
  return Math.round(toNumber(credits) * 100);
};

export const formatCents = (credits: NumericLike): string => {
  const cents = creditsToCents(credits);
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(cents);
};


